import React, { Component } from "react"

import "./ChooseNewTemplateModal.css";
import { getTranslation } from "../../assets/creator/translations";
import newTemplatesArray from "../../templates/newTemplates";
import { linksGenerator } from "../../utils/welcomeModalsUtils";

class ChooseNewTemplateModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
            selectedTemplate: 0,
            internal: true
        }
	}

	toggleSelection = (id, isInternal) => {
		this.setState({ 
            selectedTemplate: id,
            internal: isInternal
        });
	}

    handleSelectConfirmButtonClick = async () => {
        if (this.state.internal) {
            this.props.onInternalNew();
            return;
        }
        const link = await linksGenerator();
        const b2bCreatorLink = link.b2b + "?template=0" + `&lang=${this.props.lang}`;
        window.location.href = b2bCreatorLink;
	}

	render() {
        return (
			<div className="choose-new-template-modal">
				<div className="choose-new-template-modal__wrapper">
                    <p className="choose-new-template-modal__header">{getTranslation("Btn_Begin")}</p>
                    <p className="choose-new-template-modal__text">{getTranslation("ChooseNewTemplate")}</p>
        
                    <div className="choose-new-template-modal__buttons">
                        {newTemplatesArray.map(({id, name, description, img, imgAlt, internal}) => (
                            <div key={id} className="choose-new-template-modal__buttonWrapper">
                                <button 
                                    className={`choose-new-template-modal__button ${ this.state.selectedTemplate === id && "overlay_active"}`} 
                                    onClick={() => {this.toggleSelection(id, internal)}}
                                >
                                    <img src={img} alt={imgAlt}></img>
                                    <span>{getTranslation(description)}</span>
                                </button>
                                <span className={`choose-new-template-modal__label ${ this.state.selectedTemplate === id && "text_active"}`}>
                                    {getTranslation(name)}
                                </span>
                            </div>
                        ))}
                    </div>

                    <div className="choose-new-template-modal__return">
                        <p onClick={this.props.onReturn}>
                            {getTranslation("Btn_Return")}
                        </p>
                        <button
							className='templates-menu-modal__btn-group--btn templates-menu-modal__btn-group--btn--active templates-menu-modal__btn-group--chooseBtn'
							onClick={this.handleSelectConfirmButtonClick}>
							{getTranslation("Btn_Confirm")}
						</button>
					</div>
					<span className="border-line"></span>
                 </div>
            </div>
        )
    }
}


export default ChooseNewTemplateModal;